<div class="slider-container">
    <div class="custom-slider">
        <ngx-slider
            [(value)]="currentValue"
            [options]="options"
            (userChangeStart)="onUserChangeStart($event)"
            (userChange)="onUserChange($event)"
            (userChangeEnd)="onUserChangeEnd($event)">
        </ngx-slider>
    </div>
</div>
